export default function getStudyComment(userId, study) {
    let token = localStorage.getItem("token");
    let url = `/wp-json/achim/v1/user/${userId}/study/${study}`;
    let options = {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    };
    return fetch(url, options)
        .then((response) => {
            return response.json();
        })
        .then((jsonObject) => {
            return jsonObject;
        });
}